(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  setTimeout(function() { 
  $(document).ready(function(e){
      $('.toolbar-right .CollectionToolbar__Group').click(function () {
      $('html').addClass('collection');
      });
      $('.selected-change li[data-val]').click(function () {
        $('#select-item').val($(this).data('val')).trigger('change');
      });
      $('.sort-per-page select.num').on('change', function(){
        window.location.replace(jQuery(this).val());
      });
      var perpage = $('.selected-change li[selected]').html();
      setTimeout(function() { 
        var select = $('button.Popover__Value.is-selected').html();
        $('.CollectionToolbar .CollectionToolbar__Group .CollectionToolbar__Item .option-selected').html(select);
        }, 2000);
      $('.sort-per-page.custom li.init').html(perpage);
      $('.CollectionToolbar .CollectionToolbar__Group .CollectionToolbar__Item').click(function () {
        setTimeout(function() { 
        var select = $('button.Popover__Value.is-selected').html();
        $('.CollectionToolbar .CollectionToolbar__Group .CollectionToolbar__Item .option-selected').html(select);
        }, 3000);
     });
  });
  }, 3000);
  setTimeout(function() { 
    $(function() {
        $(".CollectionToolbar .sort-per-page.custom").on("click", function(e) {
          $(".CollectionToolbar .sort-per-page.custom").toggleClass("active");
           $(this).find(".selected-change.num").toggleClass("active");
          e.stopPropagation()
        });
        $(document).on("click", function(e) {
          if ($(e.target).is(".CollectionToolbar .sort-per-page.custom") === false) {
            $(".CollectionToolbar .sort-per-page.custom").removeClass("active");
            $(this).find(".selected-change.num").removeClass("active");
          }
        });
        });
  }, 3000);

  } catch(e) { console.error(e); }
})();
})();
